import { useTranslation } from "react-i18next";

import { Skeleton } from "@/components/ui/v2/skeleton";

const SKELETON_ROWS = [0, 1, 2];

export function NotificationSettingsSkeleton() {
  const { t } = useTranslation();

  return (
    <div data-testid="notification-settings-loading" role="status">
      <span className="sr-only">{t("notificationSettings.loading")}</span>
      <div aria-hidden data-slot="panel" className="rounded-lg border border-border bg-card">
        <div className="flex items-center gap-4 px-4 py-6">
          <Skeleton className="size-10 shrink-0 rounded-full motion-reduce:animate-none" />
          <div className="flex min-w-0 flex-col gap-2">
            <Skeleton className="h-4 w-40 motion-reduce:animate-none" />
            <Skeleton className="h-4 w-72 max-w-full motion-reduce:animate-none" />
          </div>
        </div>
        <ul className="divide-y divide-border border-t border-border">
          {SKELETON_ROWS.map((row) => (
            <li key={row} className="flex items-center justify-between gap-6 px-4 py-4">
              <div className="flex flex-col gap-2">
                <Skeleton className="h-4 w-56 motion-reduce:animate-none" />
                <Skeleton className="h-4 w-80 max-w-full motion-reduce:animate-none" />
              </div>
              <Skeleton className="h-[26px] w-12 shrink-0 rounded-full motion-reduce:animate-none" />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
